"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fontIcon = _interopRequireWildcard(require("../font-icon"));

var _label = require("../label");

var _tokens = require("../../../tokens");

var _versions = require("../../_utils/versions");

var _context = require("../../context");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  vertical-align: super;\n  padding-left: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  opacity: 0;\n  position: absolute;\n  user-select: none;\n\n  &:checked + ", " {\n    border: 1px solid ", ";\n    background-color: ", ";\n    &:after {\n      display: block;\n    }\n\n    &:hover {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 2px;\n  outline: none;\n  &:hover,\n  &:focus {\n    outline: none;\n    box-shadow: ", ";\n    border-color: ", ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    display: none;\n    left: 6px;\n    top: 3px;\n    width: 4px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    transform: rotate(45deg);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  height: ", ";\n  position: relative;\n  cursor: pointer;\n\n  > ", " {\n    padding-left: ", ";\n    vertical-align: 3px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var width = '18px';
var height = '18px';

var getStyles = function getStyles(props) {
  var checkboxColors = (0, _versions.getColor)(props, 'checkbox');
  return {
    border: checkboxColors.border,
    off: checkboxColors.offBackground,
    on: checkboxColors.onBackground,
    text: checkboxColors.text,
    borderHover: checkboxColors.borderHover,
    checkedHover: checkboxColors.checkedHover
  };
};

var StyledCheckbox = _styledComponents["default"].span(_templateObject(), height, _fontIcon.StyledIcon, _tokens.spacing.xsmall);

var Checkmark = _styledComponents["default"].span(_templateObject2(), height, width, function (props) {
  return getStyles(props).off;
}, function (props) {
  return getStyles(props).border;
}, function (props) {
  return props.shadowOnHover && "0 0 0 1px rgba(0, 0, 0, 0.3)";
}, function (props) {
  return getStyles(props).borderHover;
});

var Box = _styledComponents["default"].input(_templateObject3(), Checkmark, function (props) {
  return getStyles(props).checkedHover;
}, function (props) {
  return getStyles(props).on;
}, function (props) {
  return getStyles(props).checkedHover;
});

var CheckboxLabel = _label.StyledLabelText['label1'].extend(_templateObject4(), _tokens.spacing.xsmall);

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Checkbox, _React$Component);

  function Checkbox(props) {
    var _this;

    _classCallCheck(this, Checkbox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Checkbox).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onToggle", function (evt) {
      evt.stopPropagation();
      if (_this.props.readOnly) return;

      _this.setState(function (currentState) {
        if (_this.props.onToggle) _this.props.onToggle(!currentState.checked);
        return {
          checked: !currentState.checked
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "keyUpHandler", function (evt) {
      if (evt.which === 13) {
        _this.onToggle(evt);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (newProps) {
      if (newProps.checked !== _this.state.checked) _this.setState({
        checked: newProps.checked
      });
    });

    _this.state = {
      checked: props.checked
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          shadowOnHover = _this$props.shadowOnHover,
          icon = _this$props.icon;
      return _react["default"].createElement(StyledCheckbox, {
        onClick: this.onToggle,
        onKeyUp: this.keyUpHandler
      }, _react["default"].createElement(Box, {
        type: "checkbox",
        checked: this.state.checked,
        readOnly: this.props.readOnly,
        version: this.props.version,
        tabIndex: -1
      }), _react["default"].createElement(Checkmark, {
        version: this.props.version,
        shadowOnHover: shadowOnHover,
        tabIndex: 0
      }), icon && _react["default"].createElement(_fontIcon["default"], null, icon), _react["default"].createElement(CheckboxLabel, {
        version: this.props.version
      }, this.props.label));
    }
  }]);

  return Checkbox;
}(_react["default"].Component);

Checkbox.propTypes = {
  /** Function called on toggle */
  onToggle: _propTypes["default"].func,

  /** State of the toggle */
  checked: _propTypes["default"].bool,

  /** Label to show */
  label: _propTypes["default"].string,

  /** Disable flag */
  readOnly: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  shadowOnHover: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  onToggle: null,
  checked: false,
  readOnly: false,
  shadowOnHover: true
};
Checkbox.displayName = 'Checkbox';

var _default = (0, _context.withVersion)(Checkbox);

exports["default"] = _default;